<!-- 新闻 -->
<template>
  <div class="frame">
    <img
      src="http://api.zyzxgc.cn/file/static/banner_news.png"
      class="banner"
    />
    <div class="wrap">
      <div class="breadcrumb w1200">
        <bread-crumb :breadcrumbs="routerHistory"></bread-crumb>
      </div>
      <sub-nav :subNavs="subNavs"></sub-nav>
      <div class="container w1200">
        <sub-title title="行业相关" en="INDUSTRY RELATED"></sub-title>
      </div>
      <div class="box" v-if="list.length != 0">
        <div id="swiper">
          <div class="swiper-wrapper">
            <div class="swiper-slide" v-for="item in list" :key="item.id">
              <div class="in" @click="getDetail(item)">
                <img :src="URL + item.newsImageUrl" alt="" class="post" />
                <div class="title">{{ item.title }}</div>
              </div>
            </div>
          </div>
          <div class="swiper-pagination"></div>
        </div>
        <div class="desc">{{ list[activeIdx].description }}</div>
        <el-pagination
          @current-change="handleCurrentChange"
          :current-page.sync="queryParams.pageIndex"
          :page-size="queryParams.pageSize"
          layout="total, prev, pager, next"
          :total="total"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import { Store } from "@/store/index.js";
import { mapState } from "pinia";
import breadCrumb from "@/components/breadCrumb.vue";
import SubNav from "@/components/subNav.vue";
import SubTitle from "@/components/subTitle.vue";
import { URL } from "@/util/config";
export default {
  components: { breadCrumb, SubNav, SubTitle },
  data() {
    return {
      URL,
      routerHistory: [], // 当前所在位置
      subNavs: [],
      queryParams: {
        pageIndex: 1,
        pageSize: 10,
        newsCode: "3c6c9ce7017748f89de502ec67891355",
      },
      list: [],
      total: 0,
      activeIdx: 0,
      bannerList: [],
    };
  },
  computed: {
    ...mapState(Store, ["navList"]),
  },
  created() {
    this.formatBreadCrumb();
  },
  mounted() {
    this.getBanner();
    this.getList();
  },
  methods: {
    async getBanner() {
      let res = await this.$api.getBannerList({ type: 1 });
      this.bannerList = res.data;
      setTimeout(() => {
        this.initBannerSwiper();
      }, 10);
    },
    // 初始化banner swiper
    initBannerSwiper() {
      new window.Swiper("#banner", {
        autoplay: true,
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
      });
    },
    // 格式化导航条和二级导航栏
    formatBreadCrumb() {
      let nav = this.navList.find((ele) => {
        const firstPath = this.$route.path.split("/")[1];
        return ele.path != "/" && "/" + firstPath == ele.path;
      });
      if (nav.subs && nav.subs.length != 0) {
        // 二级导航栏
        this.subNavs = nav.subs;
      }
      this.routerHistory = [{ path: "/", name: "首页" }, nav];
    },
    async getList() {
      let res = await this.$api.getNewsList(this.queryParams);
      this.list = res.data.list;
      this.total = res.data.total;
      if (res.data.list.length != 0) {
        setTimeout(() => {
          this.initSwiper();
        }, 10);
      }
    },
    handleCurrentChange(val) {
      this.queryParams.pageIndex = val;
      this.getList();
    },
    initSwiper() {
      let vm = this;
      new window.Swiper("#swiper", {
        watchSlidesProgress: true, // 监听progress变化
        slidesPerView: "auto", // 一页显示数量
        centeredSlides: true, // 当前页的展示布局
        loop: true, // 反复
        autoplay: {
          disableOnInteraction: false,
          delay: 5000,
        },
        preventClicksPropagation: true,
        followFinger: false, // 松开鼠标后才开始动画
        touchRatio: 0.5, // 两倍移距一倍页数
        observer: true, // 子元素改变时触发swiper更新
        // If we need pagination
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        on: {
          slideChange() {
            vm.activeIdx = this.realIndex;
          },
          // 制定轮播策略
          progress: function () {
            for (let i = 0; i < this.slides.length; i++) {
              var slide = this.slides.eq(i);
              var slideProgress = this.slides[i].progress;
              var modify = 1;
              if (Math.abs(slideProgress) > 1) {
                modify = (Math.abs(slideProgress) - 1) * 0.5 + 1;
              }
              var translate = slideProgress * modify * 200 + "px";
              var scale = 1 - Math.abs(slideProgress) / vm.list.length;
              var zIndex = 999 - Math.abs(Math.round(10 * slideProgress));
              slide.transform(
                "translateX(" + translate + ") scale(" + scale + ")"
              );
              slide.css("zIndex", zIndex);
              slide.css("opacity", 1);
              if (Math.abs(slideProgress) > 3) {
                slide.css("opacity", 0);
              }
            }
          },
          // 制定过度动画
          setTransition: function (transition) {
            for (let i = 0; i < this.slides.length; i++) {
              let slide = this.slides.eq(i);
              slide.transition(transition);
            }
          },
        },
      });
    },
    getDetail(item) {
      window.scrollTo({ top: 200 });
      this.$router.push("/news/newDetail/" + item.id);
    },
  },
};
</script>

<style lang="scss" scoped>
.frame {
  .banner {
    width: 100%;
    height: 600px;
    object-fit: cover;
    display: block;
  }
  .wrap {
    background-image: url("http://api.zyzxgc.cn/file/static/news_bg.png");
    background-size: cover;
    background-position-x: center;

    &::before,
    &::after {
      content: "";
      display: table;
    }
  }
  .breadcrumb {
    margin: 25px auto 20px;
  }
  .container {
    margin: 70px auto 40px;
  }
  .box {
    width: 1400px;
    margin: 0 auto 120px;

    #swiper {
      height: 430px;
      overflow: hidden;
      position: relative;

      .swiper-slide {
        width: 530px;
        height: 430px;
        transition: 0.5s;
        cursor: pointer;
      }

      .in {
        height: 100%;
        position: relative;

        .title {
          width: 100%;
          padding: 10px 10px 40px;
          box-sizing: border-box;
          background-image: linear-gradient(to bottom, transparent, #000);
          color: #fff;
          font-size: 18px;
          position: absolute;
          left: 0;
          bottom: 0;
          @include ellipsis;
        }
        .post {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }
    }
    .desc {
      width: 1200px;
      margin: 20px auto;
      font-size: 15px;
      color: #5e5d5d;
      line-height: 30px;
      text-indent: 2em;
    }
  }
}

@media (max-width: 1440px) {
  .frame .box {
    width: 1200px;
  }
}
@media (max-width: 750px) {
  .frame {
    .banner {
      height: auto;
    }
    .breadcrumb {
      display: none;
    }
    .container {
      margin: 20px 0;
      padding: 0 10px;
      box-sizing: border-box;
    }
    .box {
      width: 100%;
      margin-bottom: 20px;

      #swiper {
        height: 250px;

        .swiper-slide {
          width: 100%;
          height: 100%;
        }
      }
      .desc {
        width: 100%;
        padding: 0 10px;
        box-sizing: border-box;
      }
    }
  }
}
</style>
